import { render } from "./edit-subscription.vue?vue&type=template&id=24be441c"
import script from "./edit-subscription.vue?vue&type=script&lang=js"
export * from "./edit-subscription.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__